import { render, staticRenderFns } from "./textOutlineColorController.vue?vue&type=template&id=3ce43e39&"
import script from "./textOutlineColorController.vue?vue&type=script&lang=ts&"
export * from "./textOutlineColorController.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports